import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TableContent } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { EmployeeDetailsEstateReportSchema } from "../employeeDetailsEstateReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';

const screenCode = 'EMPLOYEEDETAILSESTATEREPORT'

export function EmployeeDetailsEstateReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0"
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(EmployeeDetailsEstateReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);


    const [csvTotalRow, setCsvTotalRow] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const initialContentRowNames = ["collectionPointName", "employeeCode", "registrationNumber", "epfNo", "firstName", "nic", "cardNumber", "haverstingJobTypeName", "cardStatusDescription"];
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const initalCsvHeaders = [
        { label: "Division", value: "collectionPointName" },
        { label: "Employee Code", value: "employeeCode" },
        { label: "Reg No", value: "registrationNumber" },
        { label: "Epf No", value: "epfNo" },
        { label: "Name", value: "firstName" },
        { label: "NIC No", value: "nic" },
        { label: "Card No", value: "cardNumber" },
        { label: "Harvesting Job Type", value: "haverstingJobTypeName" },
        { label: "Card Status", value: "cardStatusDescription" }
    ];
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: ""
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEEDETAILSESTATEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeDetailsEstateReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetEmployeeDetails(searchData.groupID, searchData.operationEntityID, searchData.collectionPointID);
        createDataForExle(reportData);
        setSelectedSearchData();

        if (reportData.length > 0) {
            setIsTableHide(false);
            setReportData(reportData);
        }

    }

    async function createDataForExle(data){
        data.forEach(x => {
            var haverstingJobTypeName = "";
            x.jobTypeList.forEach(i => (
                haverstingJobTypeName = haverstingJobTypeName + i.haverstingJobTypeName + ", "
            ));
            x.haverstingJobTypeName = haverstingJobTypeName;
        });
        setExcelData(data)
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID]
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'Employee Details Report Estate',
            fileName: 'EmployeeDetailsReportEstate',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(excelData)
        copyOfCsv.push(csvTotalRow)

        copyOfCsv.push({}, {
            welfareSociety: "Group: " + selectedSearchValues.group,
            supplierName: "Factory: " + selectedSearchValues.estate
        });
        var copyOfCsv1 = _.cloneDeep(copyOfCsv)
        copyOfCsv1.push({
            welfareSociety: "User: " + tokenService.getUserNameFromToken(),
            supplierName: "Date: " + selectedSearchValues.date
        });

        xlsx(initalCsvHeaders, copyOfCsv1, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Employee Details Report Estate"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {isTableHide ? null :
                                <Grid hidden={isTableHide} item md={12} xs={12}>
                                    <MaterialTable
                                        columns={[
                                            {
                                                title: 'Division', field: 'collectionPointName',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never'
                                            },
                                            {
                                                title: 'Emp Code', field: 'employeeCode',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never'
                                            },
                                            {
                                                title: 'Reg No', field: 'registrationNumber',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never'
                                            },
                                            {
                                                title: 'Epf No', field: 'epfNo',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never'
                                            },
                                            {
                                                title: 'Name', field: 'firstName',
                                                headerStyle: { fontWeight: "bold" },
                                            },
                                            {
                                                title: 'NIC No', field: 'nic',
                                                headerStyle: { fontWeight: "bold" },
                                            },
                                            {
                                                title: 'Card No', field: 'cardNumber',
                                                headerStyle: { fontWeight: "bold" },
                                            },
                                            {
                                                title: 'Harvesting Job Type',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never',
                                                sorting: false,
                                                render: (data) => (
                                                    data.jobTypeList.map((i) => (
                                                        i.haverstingJobTypeName + ", "
                                                    ))
                                                ),
                                            },
                                            {
                                                title: 'Card Status', field: 'cardStatusDescription',
                                                headerStyle: { fontWeight: "bold" },
                                            }
                                        ]}
                                        data={reportData}
                                        options={{
                                            exportAllData: true,
                                            showTitle: false,
                                            headerStyle: { textAlign: "left", height: '1%' },
                                            cellStyle: { textAlign: "left" },
                                            columnResizable: false,
                                            pageSize: 10
                                        }}
                                    />
                                </Grid>
                            }
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Employee Details Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData} rowNames={initialContentRowNames}
                                            searchData={selectedSearchValues} columeNames={columeNames} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



